import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-banner-information',
  templateUrl: './banner-information.component.html',
  styleUrls: ['./banner-information.component.scss']
})
export class BannerInformationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
